import React from "react";
import { useTranslations } from 'next-intl'

const NumberInput = ({ id, name, addEstate, shortName, error, onChange, disabled, value, isRange, verticalRange, isHomePage }: any) => {
    const t = useTranslations('')
    return (
        <div className="mb-3">
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            {isRange ? (
                <div className="row">
                    <div className={`${verticalRange ? 'col-md-12 mb-16' : ''} ${isRange && !verticalRange ? 'col-md-6' : ''} mobile-mb-16`}>
                        <input
                            type="number"
                            className="form-control"
                            placeholder={isHomePage ? `${t('Min')} ${shortName}`: t('Min')}
                            id={`${id}-min`}
                            name={`${id}-min`}
                            value={value ? value['min'] : ''}
                            onChange={(e) => onChange(e, 'min')}
                            disabled={disabled}
                        />
                    </div>
                    <div className={`${verticalRange ? 'col-md-12' : ''} ${isRange && !verticalRange ? 'col-md-6' : ''}`}>
                        <input
                            type="number"
                            className="form-control"
                            placeholder={isHomePage ? `${t('Max')} ${shortName}`: t('Max')}
                            id={`${id}-max`}
                            name={`${id}-max`}
                            value={value ? value['max'] : ''}
                            onChange={(e) => onChange(e, 'max')}
                            disabled={disabled}
                        />
                    </div>
                </div>
            ) : (
                <input
                    type="number"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    placeholder={shortName}
                    id={id}
                    name={id}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                />
            )}
            {error && <div className="text-danger">{error.join(' ')}</div>}
        </div>
    );
};

export default NumberInput;